import MedicaidTypeLabel from './MedicaidTypeLabel';

export default MedicaidTypeLabel;
